export default "__VITE_ASSET__f2b6dd0a__"